import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { normalizeIdentityValue } from './normalizeIdentityValue';
import type { ResponseAuthorIdentity } from './ResponseAuthorIdentity';

export const deriveBaselineAuthorIdentity = (
	agent?: Pick<Agent, 'id'> &
		Partial<Pick<Agent, 'external_config_reference' | 'named_id' | 'is_default'>>,
): ResponseAuthorIdentity => {
	if (agent?.is_default) {
		return { isDefault: true };
	}

	const id = normalizeIdentityValue(agent?.id);
	const namedId = normalizeIdentityValue(agent?.external_config_reference ?? agent?.named_id);

	return {
		id,
		namedId,
		isDefault: !id && !namedId,
	};
};
